import { setHeaders, HeadersWithoutIterator } from 'owa-headers-core';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

export default function setExplicitLogonHeaders(smtp: string, headers: HeadersWithoutIterator) {
    if (headers && smtp) {
        setHeaders(headers, getExplicitLogonHeaders(smtp));
    }
}
